import { render } from "./ActiveFridges.vue?vue&type=template&id=038f9440"
import script from "./ActiveFridges.vue?vue&type=script&lang=js"
export * from "./ActiveFridges.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__